import { useAppDispatch } from 'hooks'
import { useNavigate } from 'react-router-dom'
import { persistor } from 'redux/store'
import { setIsLoggedIn } from 'redux/store/slices/authSlice'
import { pathnames } from 'utils/constants'

const useLogout = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleLogout = () => {
    dispatch(setIsLoggedIn(false))
    persistor.pause()
    persistor.flush().then(() => {
      return persistor.purge()
    })
    localStorage.clear()
    navigate(pathnames.index)
    window.location.reload()
  }

  return handleLogout
}

export default useLogout
